import React, { useState, useEffect, useCallback } from "react";
import { number } from "prop-types";

import Icons from "../../icons";
import Spinner from "./spinner";

import { prayerDistricts } from "../../utils/constant";
import { Place, Prayer, Times, convertTime, jumaCheck } from "../../utils/models/Prayer";
import { prayerApi } from "../../helper/api";
import { getStorage, setStorage } from "../../utils/utils";

import "./prayer-times.m.css";

const PrayerTimes = ({ widgetHeight }) => {
  const [city, setCity] = useState(new Place(prayerDistricts.getDistrict("Dhaka")));
  const [prayer, setPrayer] = useState();
  const [showPlaces, setShowPlaces] = useState(false);
  const [prayerIndex, setPrayerIndex] = useState();

  useEffect(() => {
    const dist = getStorage("district");
    const pTimes = getStorage("prayer-time");

    let place;

    if (dist) {
      place = new Place(dist);
      setCity(place);
    }

    if (pTimes) {
      const times = new Times(pTimes);
      if (!times.valids) {
        localStorage.removeItem("prayer-time");
        return;
      }

      const today = new Date().toLocaleDateString();
      const cacheDate = times.date.toLocaleDateString();

      if (today !== cacheDate) {
        prayerApiCalling(place);
      } else {
        const times = new Times(pTimes);
        setPrayer(new Prayer(times, place || city));
      }
    } else {
      prayerApiCalling(place);
    }
  }, []);

  const prayerApiCalling = (place) => {
    prayerApi()
      .then((res) => res.json())
      .then((res) => {
        const times = new Times(res);
        if (!times.valids) return;

        setPrayer(new Prayer(times, place || city));
        setStorage("prayer-time", res);
      })
      .catch(console.log);
  };

  useEffect(() => {
    const outsideClick = (event) => {
      if (event.target.id === "place") {
        setShowPlaces((prev) => !prev);
      } else if (event.target.id !== "places") {
        setShowPlaces(false);
      }
    };
    document.addEventListener("click", outsideClick);

    return () => document.removeEventListener("click", outsideClick);
  }, []);

  const currentHandler = useCallback((curIndex) => {
    setPrayerIndex(curIndex);
  });

  useEffect(() => {
    changeSteps();
  }, [prayerIndex]);

  const changeSteps = () => {
    const index = prayerIndex;

    const dots = document.getElementById("arrow-steps");
    const names = document.getElementById("prayers-name");
    const times = document.getElementById("prayer-times");

    if (dots && names) {
      [...dots.childNodes].slice(1).forEach((dot, i) => {
        if (i === index - 1) {
          dot.style.fill = "var(--dot-color)";
        } else {
          dot.style.fill = "var(--dot-default-color)";
        }
      });

      names.childNodes.forEach((name, i) => {
        if (i === index - 1) {
          name.style.color = "var(--rgbBlack)";
          name.style.fontWeight = "var(--bold)";
        } else {
          name.style.color = "var(--black87)";
          name.style.fontWeight = "var(--regular)";
        }
      });
      times.childNodes.forEach((name, i) => {
        if (i === index - 1) {
          name.style.color = "var(--rgbBlack)";
          name.style.fontWeight = "var(--bold)";
        } else {
          name.style.color = "var(--black87)";
          name.style.fontWeight = "var(--regular)";
        }
      });
    }
  };

  const cityChange = (district) => {
    const dist = new Place(district);
    prayer?.setPlace(dist);
    setCity(dist);
    setShowPlaces(false);
    setStorage("district", district);
  };

  return (
    <div
      styleName="base"
      style={{
        height: widgetHeight ? widgetHeight + "px" : undefined,
      }}
    >
      <div styleName="prayer">
        <div styleName="header">
          <Icons styleName="header-icon" type="prayer-header" height="190px" width="100%" />
          <div styleName="header-content">
            <h3 styleName="header-text">
              আজকের
              <br />
              নামাজের সময়সূচি
            </h3>
            <div styleName="header-place">
              <span>জেলা:</span>
              <span styleName="place" id="place">
                {city.bnName}
              </span>
              {showPlaces && (
                <div styleName="places" id="places">
                  {prayerDistricts.districts.map((district, index) => (
                    <div onClick={() => cityChange(district)} styleName="place-item" key={index}>
                      {district.bnName}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div styleName="center">
          <Spinner prayer={prayer} currnet={currentHandler} />

          <div styleName="prayers">
            <div styleName="prayers-time-steps">
              <svg width="100%" height="30" id="prayers-name" styleName="prayers-name">
                <text x="10" y="20">
                  ফজর
                </text>
                <text x="68" y="20">
                  {jumaCheck(prayer?.dhuhr)}
                </text>
                <text x="132" y="20">
                  আসর
                </text>
                <text x="188" y="20">
                  মাগরিব
                </text>
                <text x="258" y="20">
                  এশা
                </text>
              </svg>
              <svg
                styleName="arrow-steps"
                width="268"
                height="12"
                viewBox="0 0 268 12"
                fill="none"
                id="arrow-steps"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y="4.5" width="268" height="4" fill="black" fillOpacity="0.12" />
                <circle cx="12" cy="6" r="6" />
                <circle cx="73" cy="6" r="6" />
                <circle cx="134" cy="6" r="6" />
                <circle cx="195" cy="6" r="6" />
                <circle cx="256" cy="6" r="6" />
              </svg>
              <svg id="prayer-times" width="100%" height="24" styleName="prayers-times">
                <text x="6" y="16">
                  {convertTime(prayer?.fajr)}
                </text>
                <text x="70" y="16">
                  {convertTime(prayer?.dhuhr)}
                </text>
                <text x="130" y="16">
                  {convertTime(prayer?.asr)}
                </text>
                <text x="190" y="16">
                  {convertTime(prayer?.maghrib)}
                </text>
                <text x="250" y="16">
                  {convertTime(prayer?.isha)}
                </text>
              </svg>
            </div>
          </div>
        </div>
        <div styleName="bottom">
          <div styleName="bottom-up">
            <Icons styleName="sunrise-icon" type="prayer-sunrise" height="24" width="24" />
            <div styleName="sunrise-content">
              <div styleName="sunrise-text">{prayer?.currentSunrise?.text}</div>
              <div styleName="sunrise-time"> ভোর {prayer?.currentSunrise?.time}</div>
            </div>
          </div>
          <div styleName="bottom-down">
            <div styleName="content">
              <div styleName="sahri-text">{prayer?.currentSehri?.text}</div>
              <div styleName="sahri-time">ভোর {prayer?.currentSehri?.time}</div>
            </div>

            <div styleName="content">
              <div styleName="iftar-text">{prayer?.currentIftar?.text}</div>
              <div styleName="iftar-time">সন্ধ্যা {prayer?.currentIftar?.time}</div>
            </div>
          </div>
        </div>
        <div styleName="prayer-footer">সূত্র: ইসলামিক ফাউন্ডেশন বাংলাদেশ</div>
      </div>
    </div>
  );
};

PrayerTimes.propTypes = {
  widgetHeight: number,
};

export { PrayerTimes };
